import { createAuth } from "./auth/createAuth.js";
import { createGameContainer } from "./game.js";
import { startGame } from "../index.js";
import { drawTable } from "./table.js";
import "../CSS/menu.css";
import dotenv from "dotenv";

dotenv.config();

export function createMenu() {
  const gameplay = document.getElementById("gameplay");
  // container //
  const menuCreate = document.createElement("div");
  menuCreate.classList = "container";
  menuCreate.id = "menu";
  gameplay.appendChild(menuCreate);

  const puzzleStart = document.createElement("div");
  puzzleStart.classList = "menu-style";
  puzzleStart.id = "puzzle-start";
  menuCreate.appendChild(puzzleStart);

  // Puzzle title //
  const blank = document.createElement("div");
  blank.classList = "menu__background";
  puzzleStart.appendChild(blank);

  const title = document.createElement("h1");
  title.classList = "menu__title";
  title.innerText = "puzzle";
  blank.appendChild(title);

  // label //
  const info = document.createElement("label");
  info.classList = "menu_howToPlay";
  info.innerText = "Surinkite paveiksliuką atlikę mažiausiai paspaudimų";
  puzzleStart.appendChild(info);

  const label = document.createElement("label");
  label.for = "size";
  label.classList = "menu__label";
  label.innerText = "Pasirinkite sudėtingumo lygį:";
  puzzleStart.appendChild(label);

  // select //
  const selectMenu = document.createElement("div");
  selectMenu.classList = "select";
  selectMenu.id = "difficulty";
  selectMenu.name = "size";
  puzzleStart.appendChild(selectMenu);

  const options = ["3", "4", "5", "6"];
  options.forEach((option) => {
    const checkboxLabel = document.createElement("label");
    const checkbox = document.createElement("input");
    checkbox.type = "radio";
    checkbox.name = "difficulty";
    checkbox.value = option;

    checkboxLabel.appendChild(checkbox);

    const labelText = document.createElement(`span`);

    switch (option) {
      case "3":
        labelText.innerText = `Lengvas`;
        break;

      case "4":
        labelText.innerText = `Vidutinis`;
        break;

      case "5":
        labelText.innerText = `Sunkus`;
        break;

      case "6":
        labelText.innerText = `Ekspertas`;
        break;
      default:
        labelText.innerText = `Pasirinkti`;
        break;
    }

    checkboxLabel.appendChild(labelText);
    const br = document.createElement("br");

    selectMenu.appendChild(checkboxLabel);
    selectMenu.appendChild(br);
  });

  const table = document.createElement("button");
  table.innerText = "Rezultatai";
  table.innerText = table.innerText.toUpperCase();
  table.classList = "menuButtonTable";
  table.id = "menuTable";
  selectMenu.appendChild(table);

  if (
    !window.localStorage.getItem(
      `realm-web:app(${process.env.REALM_WEB_ID}):userIds`
    )
  ) {
    const auth = document.createElement("button");
    auth.id = "authorization";
    auth.innerText = "prisijungti";
    auth.innerText = auth.innerText.toUpperCase();
    selectMenu.appendChild(auth);

    auth.addEventListener("click", () => {
      if (document.querySelector("#game")) {
        document.querySelector("#game").style.display = "none";
      } else {
        document.querySelector("#menu").style.display = "none";
      }
      document.getElementById("authorization").style.display = "none";
      createAuth();
    });
  } else {
    const logOut = document.createElement("button");
    logOut.id = "authorization";
    logOut.innerText = "atsijungti";
    logOut.innerText = logOut.innerText.toUpperCase();
    selectMenu.appendChild(logOut);

    logOut.addEventListener("click", (e) => {
      e.preventDefault();
      window.localStorage.clear();
      window.location.assign("/");
    });
  }

  selectMenu.addEventListener("click", (e) => {
    let difficulty = e.target.value;
    if (difficulty === undefined || difficulty === "") {
      return;
    }
    createGameContainer(difficulty);
    startGame(difficulty);
  });

  document.getElementById("menuTable").addEventListener("click", () => {
    drawTable();
  });
}
